import Checkbox from '@jetbrains/ring-ui/components/checkbox/checkbox'
import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import React, {memo} from 'react'

import {useDebounceValue} from '../../../../../hooks/useDebounceValue'

import styles from './ShowDependenciesCheckbox.css'

interface Props {
  count?: number
  isLoading: boolean
  checked: boolean
  onChange(): void
}

const STATE_DEBOUNCE = 1000 //ms

function ShowDependenciesCheckboxComponent(props: Props) {
  const {checked, count, isLoading, onChange} = props

  const debouncedLoading = useDebounceValue(isLoading, STATE_DEBOUNCE)

  return (
    <Checkbox
      labelClassName={styles.label}
      cellClassName={styles.cell}
      containerClassName={styles.container}
      checked={checked}
      onChange={onChange}
    >
      {count != null && !isLoading
        ? `Show ${count} matches from dependencies`
        : 'Show parameters from dependencies'}
      {debouncedLoading && <LoaderInline className={styles.loader} />}
    </Checkbox>
  )
}

export const ShowDependenciesCheckbox = memo<Props>(ShowDependenciesCheckboxComponent)
